// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightPreprintReport-cls1_V1N","cls2":"CiterightPreprintReport-cls2_cD_ CiterightPreprintReport-cls1_V1N"};